import GoogleFontLoader from 'react-google-font-loader';
import { FontType } from '../../../../__generated__/graphql';

interface Props {
  font: FontType,
}

function FontPreview(props: Props) {
  const { font } = props;
  return (
    <div className="space-y-4">
      <GoogleFontLoader
        fonts={[
          {
            font: font.family,
            weights: [font.variant],
          },
        ]}
      />
      <p style={{ fontFamily: font.family }}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat.
      </p>
      <p style={{ fontFamily: font.family }}>
        Duis aute irure dolor in reprehenderit in voluptate velit esse
        cillum dolore eu fugiat nulla pariatur.
        Excepteur sint occaecat cupidatat non proident,
        sunt in culpa qui officia deserunt mollit anim id est laborum.
      </p>
    </div>
  );
}

export default FontPreview;
